export const FILTER_WINDOW_SIZE = {
  WIDTH: 620,
  HEIGHT: 500
}
